export default {
    props: {
        paddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'padding.bottom'
        }, 
        paddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'padding.left'
        }, 
        paddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'padding.right'
        }, 
        paddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'padding.top'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-barcodes-vue-wrapper/src/KendoBarcode/Padding.js